import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente } from '../../usuario/usuario-perfil';


/** Acessos permitidos a consulta dos GEPs dos pedidos */
export const acessosPedidoGep: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilAtendente];

@Injectable()
export class CanActivatePedidoGep implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosPedidoGep);
    }
}
